import { useEffect } from "react";

export const PreventPageClose = () => {
    useEffect(() => {
        const handleBeforeUnload = (event: BeforeUnloadEvent) => {
            event.preventDefault();
            return (event.returnValue = "The assessment is incomplete untill you submit it. Are you sure you want to leave?");
        };

        window.addEventListener("beforeunload", handleBeforeUnload);

        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, []);
    
    return null;
}